import React, { ReactNode } from 'react'
import { Button } from '@enamelai/design-system'

export type StepPanelContainerProps = {
  title: ReactNode
  editable?: boolean
  branchLabel?: string
  confirmLabel?: string
  confirmDisabled?: boolean
  cancelDisabled?: boolean
  onCancel: () => void
  onDone: () => void
  children: ReactNode
}

const StepPanelContainer = ({
  title,
  editable = true,
  branchLabel,
  confirmLabel = 'Save',
  confirmDisabled = false,
  cancelDisabled = false,
  onCancel,
  onDone,
  children,
}: StepPanelContainerProps): React.ReactElement => {
  const showBranch =
    branchLabel != null && String(branchLabel).trim().length > 0

  return (
    <div className="scp-call-flow-side-panel scp-step-config-panel">
      <div className="scp-panel-title">
        <span>
          {title}
          {showBranch ? (
            <span className="scp-subtitle"> ({branchLabel})</span>
          ) : null}
        </span>
      </div>
      <div className="scp-panel-body">{children}</div>
      <div className="scp-panel-footer">
        <div></div>
        <div className="component-buttons">
          {editable ? (
            <>
              <Button
                type="button"
                size="sm"
                variant="secondary"
                disabled={cancelDisabled}
                onClick={onCancel}
              >
                Cancel
              </Button>
              <Button
                type="button"
                size="sm"
                variant="primary"
                disabled={confirmDisabled}
                onClick={onDone}
              >
                {confirmLabel}
              </Button>
            </>
          ) : (
            <Button
              type="button"
              size="sm"
              variant="secondary"
              onClick={onCancel}
            >
              Close
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default StepPanelContainer
